import React, { useEffect, useState } from "react";
import { SEARCH_VIDEO_BY_KEYWORD_API, YOUTUBE_VIDEOS_API } from "../utils/contants";
import VideoCard, { AdVideoCard } from "./VideoCard";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const VideoContainer = () => {
  const [videos, setVideos] = useState([]);
  const searchButton = useSelector((store)=> store.app.searchButton);


  useEffect(() => {
    getVideos();
  }, [searchButton]);

  const getVideos = async () => {
    // console.log(searchButton);
    // console.log(SEARCH_VIDEO_BY_KEYWORD_API+searchButton);

    if(searchButton==='mostPopular'){
    const data = await fetch(YOUTUBE_VIDEOS_API)
    const json = await data.json();
    setVideos(json.items);
    }else{
    const data = await fetch(SEARCH_VIDEO_BY_KEYWORD_API+searchButton)
    const json = await data.json();
      if(json?.error?.code===403){
        const data = await fetch(YOUTUBE_VIDEOS_API)
        const json = await data.json();
        setVideos(json.items);
      }
      else{
        setVideos(json.items);
      }
    }
  };

  return (
    
    <div className="md:w-screen w-[95%] flex flex-wrap">
      {videos[0] && <AdVideoCard info={videos[0]} />}
      {videos.map((video) => (
        <Link key={video.id} to={"/watch?v=" + video.id}>
          <VideoCard info={video} />
        </Link>
      ))}
    </div>
  );
};

export default VideoContainer;
